"use client";

import type { VariantProps } from "class-variance-authority";
import { createContext, use } from "react";

import type { rootStyles } from "./style";

export const BadgeRootContext = createContext<Partial<VariantProps<typeof rootStyles>>>({});

export const useBadgeRootContext = () => use(BadgeRootContext);
